import { Logger } from '@tools/logger/logger';
import { requestsMixin } from '@tools/requests-mixin';

export const userSettingMixin = {
  mixins: [ requestsMixin ],
  methods: {
    /**
     * Enable Setting
     */
    enableUserSetting(settingURL) {
      this.post(settingURL).catch((error) => Logger.error(error));
    },
  },
};
